const getParam = (paramName: string): string | null => {
  try {
    if (typeof window !== 'undefined') {
      return new URLSearchParams(window.location.search.substring(1)).get(paramName);
    }
  } catch {
    return null;
  }
  return null;
};

export const isTrackingDisabled = (): boolean => getParam('notrack_fa') === 'true';
